import { z } from 'zod';

export const AccountSettingSchema = z.object({
  value: z.nullable(z.string()),
  setting: z.string(),
});

// TypeScript Interfaces
export type AccountSettingResponse = z.infer<typeof AccountSettingSchema>;
